import InfoContext from "pages/InfoContext";
import { useContext, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import "./MissionFeeForm.scss";
import { Typography } from "core/typography/Typography";
import { renderInputFeeComment, renderMissionFeeInput } from "../CommonInputs";
import {
  MISSION_FORM_LABELS,
  MISSION_FORM_PLACEHOLDERS,
  RULES,
} from "constants/forms";
import proptypes from "prop-types";

const MissionFeeForm = ({
  readOnly = false,
  control,
  register,
  setValue,
  watch,
  errors,
  clearErrors,
}) => {
  const { currencyType, cellHighlight } = useContext(InfoContext);
  const intl = useIntl();

  const transport_fee = watch("transport_fee", "");
  const transport_fee_comment = watch("transport_fee_comment", "");
  const restoration_fee_comment = watch("restoration_fee_comment", "");
  const restoration_fee = watch("restoration_fee", "");
  const contract_sharepoint_url = watch("contract_sharepoint_url", "");

  useEffect(() => {
    if (transport_fee || transport_fee_comment) {
      clearErrors("transport_fee");
      clearErrors("transport_fee_comment");
    }
  }, [transport_fee, transport_fee_comment]);

  useEffect(() => {
    if (restoration_fee || restoration_fee_comment) {
      clearErrors("restoration_fee");
      clearErrors("restoration_fee_comment");
    }
  }, [restoration_fee_comment, restoration_fee]);

  const transport_fee_missing_data =
    !transport_fee && transport_fee !== 0 && !transport_fee_comment;
  const restoration_fee_missing_data =
    !restoration_fee && restoration_fee !== 0 && !restoration_fee_comment;

  return (
    <div className="section-fee">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={<FormattedMessage id="fee" defaultMessage="FRAIS" />}
      />
      <div className="block">
        <div className="left-child">
          <div
            className={`cell-padding ${
              transport_fee_missing_data && cellHighlight && "errorCellColor"
            }`}
          >
            {renderMissionFeeInput({
              errorMessage:
                transport_fee_missing_data && cellHighlight
                  ? "mission_fee_error"
                  : null,
              control,
              register,
              setValue,
              pattern: RULES.positive_max_9999_decimal,
              readOnly,
              required: !transport_fee_comment,
              name: "transport_fee",
              value: transport_fee,
              clearErrors,
              errors,
              label: `${intl.formatMessage({
                id: MISSION_FORM_LABELS.transport_fee.id,
                defaultMessage: MISSION_FORM_LABELS.defaultMessage,
              })} (${currencyType})`,
              placeholder: MISSION_FORM_PLACEHOLDERS.transport_fee,
            })}
          </div>
          <div
            className={`cell-padding ${
              transport_fee_missing_data && cellHighlight && "errorCellColor"
            }`}
          >
            {renderInputFeeComment({
              control,
              clearErrors,
              register,
              required: !transport_fee && transport_fee !== 0,
              readOnly,
              value: transport_fee_comment,
              width: "100%",
              errors,
              label: MISSION_FORM_LABELS.transport_fee_comment,
              placeholder: MISSION_FORM_LABELS.transport_fee_comment,
              name: "transport_fee_comment",
            })}
          </div>
        </div>
        <div className="center-child">
          <div
            className={`cell-padding ${
              restoration_fee_missing_data && cellHighlight && "errorCellColor"
            }`}
          >
            {renderMissionFeeInput({
              errorMessage:
                restoration_fee_missing_data && cellHighlight
                  ? "mission_fee_error"
                  : null,
              control,
              pattern: RULES.positive_max_9999_decimal,
              register,
              required: !restoration_fee_comment,
              setValue,
              value: restoration_fee,
              readOnly,
              name: "restoration_fee",
              errors,
              label: `${intl.formatMessage({
                id: MISSION_FORM_LABELS.restoration_fee.id,
                defaultMessage: MISSION_FORM_LABELS.defaultMessage,
              })} (${currencyType})`,
              placeholder: MISSION_FORM_PLACEHOLDERS.restoration_fee,
            })}
          </div>
          <div
            className={`cell-padding ${
              restoration_fee_missing_data && cellHighlight && "errorCellColor"
            }`}
          >
            {renderInputFeeComment({
              control,
              register,
              width: "100%",
              required: !restoration_fee && restoration_fee !== 0,
              value: restoration_fee_comment,
              readOnly,
              errors,
              label: MISSION_FORM_LABELS.transport_fee_comment,
              placeholder: MISSION_FORM_LABELS.transport_fee_comment,
              name: "restoration_fee_comment",
            })}
          </div>
        </div>
        <div className="right-child">
          <div className="cell-padding">
            {renderMissionFeeInput({
              control,
              register,
              required: false,
              value: watch("other_fee_comment"),
              setValue,
              readOnly,
              name: "other_fee_comment",
              errors,
              label: `${intl.formatMessage({
                id: MISSION_FORM_LABELS.other_fee_comment.id,
                defaultMessage:
                  MISSION_FORM_LABELS.other_fee_comment.defaultMessage,
              })} (${currencyType})`,
            })}
          </div>
          <div
            className={`cell-padding ${
              !contract_sharepoint_url && cellHighlight && "errorCellColor"
            }`}
          >
            {renderInputFeeComment({
              control,
              register,
              readOnly,
              required: true,
              width: "100%",
              errors,
              label: MISSION_FORM_LABELS.contract_sharepoint_url,
              placeholder: MISSION_FORM_PLACEHOLDERS.contract_sharepoint_url,
              name: "contract_sharepoint_url",
              errorMessage:
                errors?.["contract_sharepoint_url"]?.message || null,
              patternMessage: "contract_sharepoint_url",
              pattern: RULES.sharepoint_url,
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionFeeForm;

MissionFeeForm.propTypes = {
  readOnly: proptypes.bool,
  control: proptypes.object,
  register: proptypes.func,
  setValue: proptypes.func,
  watch: proptypes.func,
  errors: proptypes.object,
  clearErrors: proptypes.func,
};
